import { 
  Leaf, Users, Activity, Heart, Sun, Droplet
} from 'lucide-react';

export interface Service {
  id: string;
  title: string;
  shortDesc: string;
  fullDesc: string;
  icon: any; // Using any for simplicity with Lucide icons in data file, or could map later
  image: string;
  benefits: string[];
}

export const servicesData: Service[] = [
  {
    id: "ayurvedic-health-tonic",
    title: "Ayurvedic Health Tonic",
    shortDesc: "Revitalize Your Energy and Confidence Naturally.",
    fullDesc: "Our signature Ayurvedic Health Tonic is a potent blend of ancient herbs designed to restore your body's natural balance. Crafted from time-honored recipes, this tonic targets deep-seated fatigue, boosts your immune system, and re-ignites your internal fire. It's not just a drink; it's a daily ritual for vitality.",
    icon: Droplet,
    image: "/images/services/Custom Formulations.jpg",
    benefits: [
      "Boosts daily energy levels naturally",
      "Supports immune system function",
      "Improves digestion and metabolism",
      "Enhances mental clarity and focus"
    ]
  },
  {
    id: "sexual-wellness-boosters",
    title: "Sexual Wellness Boosters",
    shortDesc: "Herbal solutions designed to enhance libido, performance, and overall sexual health naturally.",
    fullDesc: "Reclaim your confidence and performance with our specialized Sexual Wellness Boosters. Formulated with potent aphrodisiacs and stamina-enhancing herbs like Ankoro (Congo Dust), these solutions are designed to address modern stressors that affect intimacy. Experience a natural surge in drive and endurance.",
    icon: Heart,
    image: "/images/services/Sexual Wellness Boosters.jpg",
    benefits: [
      "Enhances natural libido and drive",
      "Improves stamina and endurance",
      "Supports healthy blood flow",
      "100% natural, discreet solution"
    ]
  },
  {
    id: "personalized-consultation",
    title: "Personalized Consultation",
    shortDesc: "One-on-one consultations to create a personalized herbal plan for optimal well-being.",
    fullDesc: "Every individual is unique. Our Personalized Consultation service connects you with expert herbalists who understand the nuances of the Mufasa Protocol. We analyze your lifestyle, goals, and health history to craft a tailored regimen that ensures maximum effectiveness and safety.",
    icon: Users,
    image: "/images/services/Personalized Consultation.jpg",
    benefits: [
      "Tailored herbal recommendations",
      "Lifestyle and dietary advice",
      "Ongoing support and adjustments",
      "Confidential and judgement-free"
    ]
  },
  {
    id: "herbal-supplements",
    title: "Herbal Supplements",
    shortDesc: "Natural, high-quality supplements to support overall health and enhance vitality.",
    fullDesc: "Our range of Herbal Supplements brings the power of the jungle to your daily routine. From single-herb capsules to complex synergistic blends, we ensure the highest quality sourcing. Whether you need stress support, better sleep, or joint health, our supplements are pure, potent, and proven.",
    icon: Leaf,
    image: "/images/services/Herbal Supplements.jpg",
    benefits: [
      "Standardized extracts for consistency",
      "Easy-to-take daily capsules",
      "Free from synthetic fillers",
      "Sourced from sustainable farms"
    ]
  },
  {
    id: "detox-programs",
    title: "Detox Programs",
    shortDesc: "Effective detox solutions to cleanse, rejuvenate, and improve sexual health naturally and safely.",
    fullDesc: "Modern life fills our bodies with toxins that sap our energy and drive. Our Detox Programs are designed to gently but effectively cleanse your system. By removing impurities, you pave the way for better nutrient absorption, clearer skin, and dramatically improved energy levels.",
    icon: Activity,
    image: "/images/services/Detox Programs.webp",
    benefits: [
      "Flushes out accumulated toxins",
      "Resets your digestive system",
      "Boosts natural energy production",
      "Prepares body for performance boosters"
    ]
  },
  {
    id: "stress-relief-solutions",
    title: "Stress Relief Solutions",
    shortDesc: "Herbal remedies designed to reduce stress and promote mental and emotional balance.",
    fullDesc: "Stress is the enemy of performance. Our Stress Relief Solutions utilize adaptogenic herbs that help your body cope with physical and mental strain. Find your calm center without sedation, allowing you to remain sharp, focused, and in control of your kingdom.",
    icon: Sun,
    image: "/images/services/Stress Relief Solutions.jpg",
    benefits: [
      "Reduces cortisol levels naturally",
      "Promotes deep, restorative sleep",
      "Calms the mind without drowsiness",
      "Supports emotional resilience"
    ]
  }
];
